"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var types_1 = require("@wix/social-groups-api/dist/src/types");
var social_groups_api_1 = require("@wix/social-groups-api");
var BaseGroupsController_1 = require("../common/BaseGroupsController");
var UpdateProgress_1 = require("@wix/social-groups-common/dist/src/components/ContentEditor/UpdateProgress");
var tpa_settings_1 = require("@wix/tpa-settings");
var settings_1 = require("../../settings");
var GroupsController = /** @class */ (function (_super) {
    tslib_1.__extends(GroupsController, _super);
    function GroupsController(controllerConfig, experiments) {
        if (experiments === void 0) { experiments = {}; }
        var _this = _super.call(this, controllerConfig, experiments) || this;
        _this.withdrawGroupCreationRequest = function (group) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var groupModel, newGroups;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        groupModel = new social_groups_api_1.Group(group.groupId, this.api, this.platformAPIs);
                        return [4 /*yield*/, groupModel.setApprovalStatus(types_1.ApiTypes.v1.GroupApprovalStatus.CANCELLED)];
                    case 1:
                        _a.sent();
                        newGroups = this.state.groups.filter(function (item) { return item.groupId !== group.groupId; });
                        this.platformAPIs.pubSub.publish(social_groups_api_1.APP_TOAST_EVENT, {
                            type: social_groups_api_1.AppToastTypes.GROUP_CANCELLED,
                            options: {
                                'group-name': group.details.title,
                            },
                        }, false);
                        this.setState({
                            groups: newGroups,
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.setPendingGroupApprovalStatus = function (group, status, rejectionReason) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var groupModel, groupResponse, newGroups, toastType;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        groupModel = new social_groups_api_1.Group(group.groupId, this.api, this.platformAPIs);
                        return [4 /*yield*/, groupModel.setApprovalStatus(status, rejectionReason)];
                    case 1:
                        groupResponse = _a.sent();
                        switch (status) {
                            case types_1.ApiTypes.v1.GroupApprovalStatus.APPROVED:
                                newGroups = this.state.groups.map(function (item) {
                                    return item.groupId === groupResponse.groupId ? groupResponse : item;
                                });
                                toastType = social_groups_api_1.AppToastTypes.GROUP_APPROVED;
                                break;
                            case types_1.ApiTypes.v1.GroupApprovalStatus.REJECTED:
                                newGroups = this.state.groups.filter(function (item) { return item.groupId !== group.groupId; });
                                toastType = social_groups_api_1.AppToastTypes.GROUP_DECLINED;
                                break;
                            default:
                            // not gonna happen ™
                        }
                        this.platformAPIs.pubSub.publish(social_groups_api_1.APP_TOAST_EVENT, {
                            type: toastType,
                            options: {
                                'group-name': group.details.title,
                            },
                        }, false);
                        this.setState({
                            groups: newGroups,
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.searchGroups = function (groupNameQuery) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.groupListModel.search(groupNameQuery)];
                    case 1:
                        _a.sent();
                        this.populateGroupsList();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.sortGroups = function (sortBy) {
            if (sortBy === void 0) { sortBy = types_1.ApiTypes.v1.GroupsSortBy.RECENT_ACTIVITY; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.groupListModel.sort(sortBy)];
                        case 1:
                            _a.sent();
                            this.populateGroupsList();
                            return [2 /*return*/];
                    }
                });
            });
        };
        return _this;
    }
    GroupsController.prototype.getGroups = function (config) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0: 
                    //TODO: refactor for server-side query with sort
                    return [4 /*yield*/, this.groupListModel.fetch()];
                    case 1:
                        //TODO: refactor for server-side query with sort
                        _c.sent();
                        _b = (_a = this.groupListModel).sort;
                        return [4 /*yield*/, this.getSortBy()];
                    case 2: return [4 /*yield*/, _b.apply(_a, [_c.sent()])];
                    case 3:
                        _c.sent();
                        return [2 /*return*/, this.groupListModel.getGroups()];
                }
            });
        });
    };
    GroupsController.prototype.getSortBy = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var groupsSortBy, settings, sortBy;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        groupsSortBy = this.groupListModel.getGroupsSortBy();
                        if (groupsSortBy) {
                            return [2 /*return*/, groupsSortBy];
                        }
                        return [4 /*yield*/, this.getGroupsInstanceSettings()];
                    case 1:
                        settings = _a.sent();
                        sortBy = !settings
                            ? types_1.ApiTypes.v1.GroupsSortBy.RECENT_ACTIVITY
                            : settings.groupsSortBy;
                        return [2 /*return*/, sortBy];
                }
            });
        });
    };
    GroupsController.prototype.updateConfig = function ($w, updatedConfig) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setApiSortingFromConfig(updatedConfig)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, _super.prototype.updateConfig.call(this, $w, updatedConfig)
                                .catch(function (e) { return console.log('Error updating config'); })];
                }
            });
        });
    };
    GroupsController.prototype.setApiSortingFromConfig = function (updatedConfig) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var settingsValuesNew, settingsValues, apiSort, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.experiments.enabled('specs.groups.GroupsSorting')) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        settingsValuesNew = this.getSettingsValues(updatedConfig);
                        settingsValues = this.getSettingsValues(this.config);
                        if (!(settingsValues.sortBy !== settingsValuesNew.sortBy)) return [3 /*break*/, 4];
                        apiSort = social_groups_api_1.GroupSortFieldMapping[settingsValuesNew.sortBy];
                        return [4 /*yield*/, this.updateGroupInstanceSettings({
                                groupsSortBy: apiSort,
                            })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.groupListModel.sort(apiSort)];
                    case 3:
                        _a.sent(); //TODO:💩
                        this.setState({ groupsSortBy: apiSort });
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        console.log('Error Updating Group App Setting');
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    GroupsController.prototype.getSettingsValues = function (config) {
        return tpa_settings_1.getSettingsValues(config.publicData.COMPONENT || {}, settings_1.settingsSettings);
    };
    GroupsController.prototype.getActions = function () {
        var actions = _super.prototype.getActions.call(this);
        return tslib_1.__assign({}, actions, { searchGroups: this.searchGroups, setPendingGroupApprovalStatus: this.setPendingGroupApprovalStatus, withdrawGroupCreationRequest: this.withdrawGroupCreationRequest, sortGroups: this.sortGroups });
    };
    GroupsController.prototype.getInitialProps = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var groups, createGroupPolicy, groupListState, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getGroups(this.config)];
                    case 1:
                        groups = _a.sent();
                        this.cacheGroups(groups);
                        return [4 /*yield*/, this.getGroupsInstanceSettings()];
                    case 2:
                        createGroupPolicy = (_a.sent()).createGroupPolicy;
                        groupListState = this.groupListModel.getState();
                        // TODO: why do we need state in controller?
                        this.state = tslib_1.__assign({}, groupListState, { createGroupPolicy: createGroupPolicy });
                        return [2 /*return*/, this.state];
                    case 3:
                        e_2 = _a.sent();
                        console.log('Groups Controller Initial Props: FAIL');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, {}];
                }
            });
        });
    };
    GroupsController.prototype.populateGroupsList = function () {
        var groupListState = this.groupListModel.getState();
        this.setState(tslib_1.__assign({}, groupListState, { updateProgress: UpdateProgress_1.UpdateProgress.STALE }));
    };
    return GroupsController;
}(BaseGroupsController_1.BaseGroupsController));
exports.default = GroupsController;
//# sourceMappingURL=GroupsController.js.map